

import { BasicClientCommand } from "../BasicClientCommand";

export class PrivateOfferIsoObjectClientCommand extends BasicClientCommand {
    public execute(commandVars: any = null): void {
        return;
    }
}

